import ApiPlanFeatures from 'types/api/PlanFeatures';
import { Locales } from 'types/locale';

import Model from 'models/Model';
import Plan from 'models/Plan';

import { select as selectLocale } from 'utils/locale';

export enum Features {
    OneActiveCourse = 'oneActiveCourse',
    ManyActiveCourses3 = 'manyActiveCourses3',
    ManyActiveCourses15 = 'manyActiveCourses15',
    Certificate = 'certificate',
    CertificateWithOwnLogo = 'certificateWithOwnLogo',
    NewCompanyPage = 'newCompanyPage',
    BasicSupport = 'basicSupport',
    PromotionSocialMedia = 'promotionSocialMedia',
    PrioritySupport = 'prioritySupport',
    SaleSupport = 'saleSupport',
    Nps = 'nps',
    CompanyPage = 'companyPage',
    NotificationCampaign = 'notificationCampaign',
    ToDoList = 'toDoList',
    Opinion = 'opinion',
    OneTeacher = 'oneTeacher',
    ThreeTeachers = '3Teachers',
    FifteenTeachers = '15Teachers',
    ExpertLabels = 'expertLabels',
}

const translationsModels = selectLocale({
    [Locales.Pl]: require('locales/models/pl.json'),
});

export default class PlanFeatures implements Model {
    id: string;
    feature: string;
    active: boolean;
    plan: Plan;

    constructor(data: ApiPlanFeatures) {
        this.id = data.id;
        this.feature = data.feature;
        this.plan = data.plan;
        this.active = data.active;
    }
}

export const planFeaturesOptions = [{
    id: Features.OneActiveCourse,
    label: translationsModels?.planFeatures?.features?.oneActiveCourse,
    value: false,
}, {
    id: Features.OneTeacher,
    label: translationsModels?.planFeatures?.features?.oneTeacher,
    value: false,
}, {
    id: Features.CompanyPage,
    label: translationsModels?.planFeatures?.features?.companyPage,
    value: false,
}, {
    id: Features.ThreeTeachers,
    label: translationsModels?.planFeatures?.features?.threeTeachers,
    value: false,
}, {
    id: Features.ManyActiveCourses3,
    label: translationsModels?.planFeatures?.features?.manyActiveCourses3,
    value: false,
}, {
    id: Features.NewCompanyPage,
    label: translationsModels?.planFeatures?.features?.newCompanyPage,
    value: false,
}, {
    id: Features.Certificate,
    label: translationsModels?.planFeatures?.features?.certificate,
    value: false,
}, {
    id: Features.ToDoList,
    label: translationsModels?.planFeatures?.features?.toDoList,
    value: false,
}, {
    id: Features.BasicSupport,
    label: translationsModels?.planFeatures?.features?.basicSupport,
    value: false,
}, {
    id: Features.FifteenTeachers,
    label: translationsModels?.planFeatures?.features?.fifteenTeachers,
    value: false,
}, {
    id: Features.ManyActiveCourses15,
    label: translationsModels?.planFeatures?.features?.manyActiveCourses15,
    value: false,
}, {
    id: Features.CertificateWithOwnLogo,
    label: translationsModels?.planFeatures?.features?.certificateWithOwnLogo,
    value: false,
}, {
    id: Features.Nps,
    label: translationsModels?.planFeatures?.features?.nps,
    value: false,
}, {
    id: Features.PromotionSocialMedia,
    label: translationsModels?.planFeatures?.features?.promotionSocialMedia,
    value: false,
}, {
    id: Features.NotificationCampaign,
    label: translationsModels?.planFeatures?.features?.notificationCampaign,
    value: false,
}, {
    id: Features.PrioritySupport,
    label: translationsModels?.planFeatures?.features?.prioritySupport,
    value: false,
}, {
    id: Features.SaleSupport,
    label: translationsModels?.planFeatures?.features?.saleSupport,
    value: false,
}, {
    id: Features.ExpertLabels,
    label: translationsModels?.planFeatures?.features?.expertLabels,
    value: false,
}];
